// src/screens/tabs/Home/components/RestaurantCard.tsx
import React, { useState } from "react";
import { View, Text, Image, TouchableOpacity, Alert } from "react-native";
import { Heart } from "lucide-react-native";
import { FlickOColors } from "../components/shared/styles/color";
import { menuScreenStyles } from "../components/shared/styles/styles";
import { useNavigation } from "@react-navigation/native";
import { NavigationProps } from "../types/navigation";
import { getResponsiveSize } from "../components/shared/styles/globalStyles";
import { GridData } from "../components/shared/types/grid";

interface RestaurantCardProps {
  restaurant: GridData;
}

export const RestaurantCard = ({ restaurant }: RestaurantCardProps) => {
  const navigation = useNavigation<NavigationProps>();
  const [isLoading, setIsLoading] = useState(false);

  const handleRestaurantPress = async (restData: GridData) => {
    try {
      const { id, updatedAt } = restData;
      console.log("handleRestaurantPress called", id);
      if (!id) {
        Alert.alert("Error", "restaurant not found");
        return;
      }

      navigation.navigate("RestaurantMenu", {
        id: id,
        updatedAt: updatedAt || "",
        onEditPress: () => {},
      });
    } catch (error) {
      console.log("error: ", error);
      Alert.alert("Error", "Unable to open restaurant details");
    }
  };

  return (
    <View style={[menuScreenStyles.categoryCard, { marginBottom: 0 }]}>
      <View style={menuScreenStyles.subCategoryContainer}>
        <View style={menuScreenStyles.menuItemsContainer}>
          <TouchableOpacity
            style={[menuScreenStyles.menuItemCard]}
            onPress={() => {
              console.log("onPress, restaurant.id: ", restaurant.id);
              if (restaurant.id) {
                console.log("handleRestaurantPress called");
                handleRestaurantPress(restaurant);
              } else {
                Alert.alert("Error", "Unable to open restaurant details");
              }
            }}
          >
            <View style={menuScreenStyles.contentSection}>
              <View style={menuScreenStyles.subCategoryHeader}>
                <Text style={menuScreenStyles.restaurantName}>
                  {restaurant.name}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: getResponsiveSize(5),
                }}
              >
                {restaurant.avgReview && (
                  <View
                    style={[
                      menuScreenStyles.ratingBadge,
                      {
                        backgroundColor:
                          parseInt(restaurant.avgReview) >= 4
                            ? FlickOColors.darkGreen
                            : parseInt(restaurant.avgReview) >= 2.5
                            ? "#FFB52E"
                            : FlickOColors.error,
                      },
                    ]}
                  >
                    <Text style={menuScreenStyles.ratingText}>
                      {restaurant.avgReview} ★
                    </Text>
                  </View>
                )}
                {restaurant.deliveryDetails?.estimatedTime && (
                  <Text style={menuScreenStyles.cuisineText}>
                    {restaurant.deliveryDetails.estimatedTime} mins
                  </Text>
                )}
              </View>
              <Text style={menuScreenStyles.cuisineText}>
                {restaurant.cuisines?.join(", ")}
              </Text>

              <View>
                <Text style={menuScreenStyles.cuisineText}>
                  {restaurant.location?.address?.locality}
                </Text>
              </View>

              {restaurant.avgCostForTwo && (
                <Text style={menuScreenStyles.cuisineText}>
                  ₹{restaurant.avgCostForTwo} for two
                </Text>
              )}
            </View>

            <View style={menuScreenStyles.imageContainer}>
              <Image
                source={
                  restaurant?.profileImg?.length
                    ? { uri: restaurant.profileImg[0] }
                    : require("../../assets/restaurant-example.jpg")
                }
                style={menuScreenStyles.itemImage}
              />
              <TouchableOpacity style={menuScreenStyles.editButton}>
                <Heart size={24} color={FlickOColors.white} />
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};
